module.exports = __webpack_public_path__ + "static/media/minimeal.1b157616.svg";